module.exports = __webpack_public_path__ + "ae30bc40b77378cf32bc8dfee48e8b40.mp4";